import React, { useState, useEffect, useRef } from "react";

export default function BusinessInfoForm({ setBusinessType, businessType, setBusinessName, setCompanyName, setBusinessDo, setTargetAudience, business_name, company_name, business_do, target_audience, onContinue }) {

  const otherInputRef = useRef(null);

  const [type, setType] = useState("");
  /* ✅ Auto focus when "Other" selected */
  useEffect(() => {
    if (type === "Other" && otherInputRef.current) {
      otherInputRef.current.focus();
    }
    else {
      setBusinessType(type)
    }
  }, [type]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h2 style={styles.title}>Tell us about your business</h2>

        <div style={styles.card}>
          {/* Business name & Industry */}
          <div style={styles.row}>
            <Field label="Business Name" placeholder="e.g., Boom Display Solutions" value={business_name} setValue={setBusinessName} />
            <Field label="Industry" placeholder="e.g., Digital Signage, Retail, Hospitality" value={company_name} setValue={setCompanyName} />
          </div>

          {/* Description */}
          <label style={styles.label}>What does your business do?</label>
          <textarea
            placeholder="Describe your business, products, or services in a few sentences..."
            value={business_do}
            onChange={(e) => setBusinessDo(e.target.value)}
            maxLength={500}
            style={{ ...styles.input, height: 120, resize: "none" }}
          />
          <div style={styles.counter}>{business_do.length}/500 characters</div>

          {/* Business type */}
          <label style={styles.label}>What do you do?</label>
          <div style={styles.optionRow}>
            {[
              "Selling Products",
              "Providing Services",
              "Community/Club",
              "Other",
            ].map((item) => (
              <Option
                key={item}
                label={item}
                active={type === item}
                onClick={() => setType(item)}
              />
            ))}
          </div>

          {/* ✅ Animated Other Input */}
          <div
            style={{
              ...styles.otherWrapper,
              ...(type === "Other"
                ? styles.otherVisible
                : styles.otherHidden),
            }}
          >
            <div>
              <input
                ref={otherInputRef}
                placeholder="Please specify what you do..."
                value={businessType}
                onChange={(e) => setBusinessType(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>


          {/* Target audience */}
          <label style={styles.label}>Who is your target audience?</label>
          <input
            value={target_audience}
            onChange={(e) => setTargetAudience(e.target.value)}
            placeholder="e.g., Small business owners, Retail managers"
            style={styles.input}
          />

          {/* Button */}
          <button style={styles.button} onClick={onContinue}>
            ✨ Continue to Brand Style
          </button>

        </div>

      </div>
    </div>
  );
}

/* ---------- Components ---------- */

const Field = ({ label, placeholder, value, setValue }) => (
  <div style={styles.field}>
    <label style={styles.label}>{label}</label>
    <input placeholder={placeholder} style={styles.input} value={value} onChange={(e) => setValue(e.target.value)} />
  </div>
);

const Option = ({ label, active, onClick }) => (
  <div
    onClick={onClick}
    style={{
      ...styles.option,
      ...(active ? styles.optionActive : {}),
    }}
  >
    {label}
  </div>
);

/* ---------- Styles ---------- */

const styles = {
  wrapper: {
    width: "100%",
    backgroundColor: "#000",
    padding: 32,
    color: 'white'
  },

  container: {
    maxWidth: 1100,
    margin: "0 auto",
  },

  title: {
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 18,
    textAlign: "left",
  },

  card: {
    width: "100%",
    background: "linear-gradient(180deg, #0F1419, #0B0F14)",
    borderRadius: 18,
    padding: 20,
    border: "2px solid #F7941D",
    boxSizing: "border-box",
  },

  row: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    marginBottom: 20,
  },

  field: {
    flex: 1,
    minWidth: 280,
  },

  label: {
    display: "block",
    marginBottom: 8,
    fontSize: 16,
    fontWeight: 600,
    textAlign: "left",
  },

  input: {
    width: "100%",
    backgroundColor: "#E9FFFF",
    borderRadius: 8,
    border: "none",
    padding: "14px 16px",
    fontSize: 16,
    outline: "none",
    marginBottom: 12,
    boxSizing: "border-box",
  },

  counter: {
    fontSize: 14,
    color: "#9CA3AF",
    marginBottom: 20,
    textAlign: "left",
    alignSelf: "flex-start", // 👈 overrides parent alignment
  },

  optionRow: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 10,
  },

  option: {
    flex: "1 1 200px",
    textAlign: "center",
    padding: "14px 10px",
    borderRadius: 8,
    border: "2px solid #2B3440",
    cursor: "pointer",
    fontWeight: 600,
    color: "#D1D5DB",
    backgroundColor: "#121821",
  },

  optionActive: {
    borderColor: "#F7941D",
    backgroundColor: "#2A1A06",
    color: "#F7941D",
  },

  /* ✅ Animation styles */
  otherWrapper: {
    display: "grid",
    gridTemplateRows: "0fr",
    transition: "grid-template-rows 0.35s ease, opacity 0.25s ease",
    opacity: 0,
  },

  otherHidden: {
    gridTemplateRows: "0fr",
    opacity: 0,
  },

  otherVisible: {
    gridTemplateRows: "1fr",
    opacity: 1,
  },


  button: {
    width: "100%",
    height: 56,
    borderRadius: 10,
    border: "none",
    backgroundColor: "#F7941D",
    fontSize: 20,
    fontWeight: 700,
    cursor: "pointer",
    color: "#000",
    marginTop: 8,
  },
};
